import { Container, Sprite } from 'pixi.js';

import { Shared } from '../../App';

export class BillboardCar extends Container
{
    public sprite: Sprite;
    public moving = false;
    public rotating = 0;

    constructor()
    {
        super();
        this.sprite = new Sprite(Shared.assets.getTexture('tt-billboard-car'));
        this.sprite.anchor.set(0.5);
        this.addChild(this.sprite);
    }

    public async goAwayForward(): Promise<void>
    {
        if (this.moving) return;
        this.moving = true;
        await Shared.game.tween.to(this.sprite, { x: 200, alpha: 0, duration: 1, ease: 'sine.in' });
        this.sprite.x = -70;
        this.moving = false;
    }

    public async goAwayBackward(): Promise<void>
    {
        if (this.moving) return;
        this.moving = true;
        await Shared.game.tween.to(this.sprite, { x: -70, alpha: 0, duration: 1, ease: 'sine.in' });
        this.sprite.x = 70;
        this.moving = false;
    }

    public async comeBack(): Promise<void>
    {
        if (this.moving) return;
        this.moving = true;
        await Shared.game.tween.to(this.sprite, { x: 0, alpha: 1, duration: 1, ease: 'sine.out' });
        this.moving = false;
    }

    public async lean(direction = 1, duration = 1): Promise<void>
    {
        if (this.rotating === -1) return;
        this.rotating = -1;
        Shared.game.tween.kill(this.sprite);
        await Shared.game.tween.to(this.sprite, { rotation: Math.PI * 0.25 * direction, duration, ease: 'sine.inOut' });
    }

    public async leanBack(): Promise<void>
    {
        if (this.rotating === 0) return;
        this.rotating = 0;
        Shared.game.tween.kill(this.sprite);
        await Shared.game.tween.to(this.sprite, { rotation: 0, duration: 0.3, ease: 'sine.out' });
    }
}
